
import ApiGo_TS from "./actions/ApiGo_TS";

// const comm_config = {"pad": 6, "cf": 4, "turn": 13};
// const comm_config = {"cf": 4};
const comm_config = {"pad": 6};

export default comm_config;

//功能開關切換
export const checkfeatureStatus = async() => {
    try {
      const res = await ApiGo_TS.getFeatureStatus();
      return res;
    } catch (error) {
      console.log('error', error);
    }
}